import {Button} from '@mantine/core';
import React from 'react';
import {EdgeLabelRenderer, EdgeProps} from 'reactflow';

import {EdgesContext} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/EdgesContext';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {getEdgeMidpointLabelCoords} from 'ui-library/reactflow/edges/ElkSplineEdgeRenderer';

export default function RemoveEdgeLabel(props: EdgeProps): JSX.Element {
  const {onEdgeRemove} = EdgesContext.useContext();
  const {labelX, labelY} = getEdgeMidpointLabelCoords(props);

  return (
    <EdgeLabelRenderer>
      <div
        style={{
          position: 'absolute',
          transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
          pointerEvents: 'all',
        }}
        className="nopan"
      >
        <Button.Group>
          <Button
            variant="tertiary"
            onClick={() => {
              onEdgeRemove(props.id);
            }}
            styles={{root: {padding: 10, width: 36, height: 36}}}
            aria-label="Remove edge"
          >
            <BenchlingIcon icon="trash-can" />
          </Button>
        </Button.Group>
      </div>
    </EdgeLabelRenderer>
  );
}
